import { StrategicJourney } from '../components/investor/StrategicJourney';

export default function StrategicInvestorPage({ onJoin }) {
  return <StrategicJourney onJoin={onJoin} />;
}